import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { Caption } from "storybook-components/Typography";
import IsRichTextValidator from "../Helpers/IsRichTextValidator";
import RichTextReadingTime from "../Helpers/RichTextReadingTime";

const Seperator = styled.span`
  display: inline-block;
  font-size: 12px;
  margin: 0 5px;
`;

const PublishDate = styled(Caption)`
  color: ${({ theme }) => theme.colors.gray12};
  margin-top: ${props => props.marginTop || "1em"};
`;

export default ({ color, marginTop, publishDate, readTime, richTextData }) => {
  const isRichTextPost = IsRichTextValidator(richTextData);
  const [richTextReadingTime, setRichTextReadingTime] = useState({});
  return (
    <>
      {isRichTextPost && (
        <RichTextReadingTime
          richTextRaw={richTextData.raw}
          callback={setRichTextReadingTime}
        />
      )}
      <PublishDate color={color} marginTop={marginTop} className="text">
        {moment(publishDate).format("LL")}
        <Seperator>&bull;</Seperator>
        {isRichTextPost ? richTextReadingTime.text : ` ${readTime} minute read`}
      </PublishDate>
    </>
  );
};
